var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mt-5"},[_c('div',{staticClass:"card text-center floating-card"},[_c('h4',{staticClass:"floating-content"},[_vm._v("Distribución por Género")]),[_c('div',{staticClass:"tamaño mx-auto"},[_c('apexchart',{attrs:{"width":"360","type":"donut","options":_vm.options,"series":_vm.series}})],1)]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }